'use es6';

import { LayoutWidget } from 'DesignData/models/layouts';
/**
 *
 * @param {NormalizedLayoutData} normalizedLayoutData
 * @returns {NormalizedLayoutData}
 */

export function cloneNormalizedLayoutData(normalizedLayoutData) {
  const {
    rootWidgetId
  } = normalizedLayoutData;
  const __rows = normalizedLayoutData.rows;
  const __widgets = normalizedLayoutData.widgets;
  const rows = Object.keys(__rows).reduce((acc, id) => {
    acc[id] = __rows[id].slice();
    return acc;
  }, {});
  const widgets = Object.keys(__widgets).reduce((acc, id) => {
    acc[id] = new LayoutWidget(JSON.parse(JSON.stringify(__widgets[id])));
    return acc;
  }, {});
  return {
    rows,
    widgets,
    rootWidgetId
  };
}